module.exports = __webpack_public_path__ + "static/img/button2.be51891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/button2.png
// module id = xEq4
// module chunks = 4